<template>
  <div class="d-inline-block">
    <v-dialog v-model="dialog" max-width="600">
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          color="primary"
          prepend-icon="mdi-folder-plus"
          variant="tonal"
          v-bind="activatorProps"
        >New Project</v-btn>
      </template>

      <v-card prepend-icon="mdi-folder-multiple" title="Create project">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="8">
              <v-text-field
                density="compact"
                placeholder="Project name*"
                prepend-inner-icon="mdi-format-title"
                variant="outlined"
                v-model="title"
                @update:modelValue="autoKey"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                density="compact"
                placeholder="Key*"
                prepend-inner-icon="mdi-key"
                variant="outlined"
                v-model="key"
                hint="e.g. PROJ"
                @update:modelValue="keyEdited = true"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                density="compact"
                placeholder="Description"
                prepend-inner-icon="mdi-text"
                variant="outlined"
                rows="2"
                v-model="description"
              ></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                prepend-inner-icon="mdi-account-multiple"
                :items="employees"
                item-title="title"
                item-value="value"
                label="Members"
                auto-select-first
                v-model="people"
                multiple
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>
          <v-btn
            color="primary"
            text="Save"
            variant="flat"
            :disabled="!title || !key"
            @click="createProject()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import constant from '@/constant';
import utils from '@/utils';
import apiMixin from '@/mixins/apiMixin';

export default {
  name: 'AddProject',
  mixins: [apiMixin],
  data() {
    return {
      dialog: false,
      title: '',
      key: '',
      keyEdited: false,
      description: '',
      people: [],
      employees: [],
      constant: constant,
    };
  },
  methods: {
    autoKey() {
      // Suggest a key from the title until the user edits the key manually.
      if (this.keyEdited) return;
      this.key = (this.title || '')
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .trim()
        .split(/\s+/)
        .map(w => w[0] || '')
        .join('')
        .toUpperCase()
        .slice(0, 6);
    },
    createProject() {
      const payload = {
        title: this.title,
        key: this.key,
        description: this.description,
        people: this.people,
      };
      axios.post(utils._api(this.constant.create_project), payload, this.authHeaders())
        .then((response) => {
          this.dialog = false;
          this.title = '';
          this.key = '';
          this.keyEdited = false;
          this.description = '';
          this.people = [];
          this.$emit('created', response.data.data);
          this.$emit('toggle-message', response.data.message);
        })
        .catch(error => {
          console.error('Error creating project:', error);
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to create project';
          this.$emit('toggle-message', msg);
        });
    },
    getUsers() {
      axios.get(utils._api(this.constant.get_active_users), this.authHeaders())
        .then((response) => {
          this.employees = (response.data.data || []).map((employee) => ({
            title: employee.fullname,
            value: employee.id
          }));
        })
        .catch(error => console.error('Error fetching users:', error));
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
